import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { showError, showSuccess } from "ReduxErrorBar";
import ReactConfirmAlert, { confirmAlert } from "react-confirm-alert";
import { COMMON_FAIL_MESSAGE } from "Constants";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { CopyToClipboard } from "react-copy-to-clipboard";
import LocaleStrings from "Languages";
import { openProposalUrl, openProposalForm } from "ProposalAction";
import { updateFormList, updateFomeName, formEdited } from "FormBuilderAction";

class FormListItem extends React.Component {
  constructor(props) {
    super(props);
    this.viewProposal = this.viewProposal.bind(this);
    this.editForm = this.editForm.bind(this);
    this.state = { copied: false };
  }

  copyUrl = () => {
    this.setState({ copied: true });

    setTimeout(() => {
      this.setState({ copied: false });
    }, 500);
  };

  viewProposal() {
    let { form } = this.props;
    //console.log('form',form);
    this.props.openProposalUrl(true, form.formnumber);
  }

  editForm() {
    let proposalform = this.props.form;
    this.props.updateFomeName(proposalform.formname); // Form Name
    var newObj = JSON.parse(proposalform.formjson);
    this.props.updateFormList(newObj, this.props.oldKeys, "samearray"); // Updating redux with editing from json
    this.props.formEdited(false); // This is used for edit form
    this.props.openProposalForm(true, proposalform);
  }

  render() {
    let { form } = this.props;
    //console.log('form',form);
    let application_startdate =
      form.proposal_by_formid &&
      form.proposal_by_formid.length > 0 &&
      form.proposal_by_formid[0].application_startdate
        ? moment(form.proposal_by_formid[0].application_startdate, "YYYY-MM-DD")
        : null;
    let application_enddate =
      form.proposal_by_formid &&
      form.proposal_by_formid.length > 0 &&
      form.proposal_by_formid[0].application_enddate
        ? moment(form.proposal_by_formid[0].application_enddate, "YYYY-MM-DD")
        : null;

    let duration =
      application_startdate && application_enddate
        ? moment(application_startdate).format("DD/MM/YYYY") +
          " - " +
          moment(application_enddate).format("DD/MM/YYYY")
        : "";

    return (
      <tr>
        <td className="first-td">{form.formnumber}</td>
        <td className="middle-td">{form.formname}</td>
        <td className="middle-td">
          {form.proposal_by_formid && form.proposal_by_formid.length > 0
            ? form.proposal_by_formid[0].proposal_name
            : ""}
        </td>
        <td className="middle-td">{form.versionno}</td>
        <td className="middle-td">{duration}</td>

        <td className="last-td" style={{ width: 400 }}>
          <div className="action-button" style={{ marginLeft: 5 }}>
            <button
              className="btn btn-custom-table-white"
              onClick={this.viewProposal}
            >
              {LocaleStrings.button_view}
            </button>
          </div>

          <div className="action-button" style={{ marginLeft: 5 }}>
            <button
              className="btn btn-custom-table-white"
              onClick={this.editForm}
            >
              {LocaleStrings.button_edit}
            </button>
          </div>
        </td>
      </tr>
    );
  }
}

export var mapStateToProps = (state) => {
  return {
    session: state.session,
    oldKeys: state.formList,
    formName: state.formName,
  };
};

export default connect(mapStateToProps, {
  openProposalUrl,
  openProposalForm,
  updateFormList,
  updateFomeName,
  formEdited,
})(FormListItem);
